import { render } from "./SonstigesEdit.vue?vue&type=template&id=5c590b09"
import script from "./SonstigesEdit.vue?vue&type=script&lang=js"
export * from "./SonstigesEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__